import React, { useEffect, useState } from 'react';
import { Button, Menu, MenuItem, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setWebLanguage } from '../store/dataslice';

const LanguageList = () => {
    const dispatch = useDispatch();
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
     const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
    const [activeLanguage, setActiveLanguage] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const languages = [
        { code: 'sq', name: ControlsTranslations.Albanian, flag: 'xk.svg' },
        { code: 'en', name: ControlsTranslations.English, flag: 'en.svg' },
        { code: 'sr', name: ControlsTranslations.Serbian, flag: 'xk.svg' }
    ];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageClick = (language) => {
        dispatch(setWebLanguage(language));
        handleClose();
    };

    useEffect(() => {
        setActiveLanguage(WebsiteLanguage)
    }, [WebsiteLanguage]);

    const getCurrentLanguage = () => {
        return languages.find(lang => lang.code === activeLanguage) || languages[0];
    };

    return (
        <div className="language-dropdown">
            <Button
                variant="text"
                onClick={handleClick}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    textTransform: 'none',
                    color: 'inherit',
                    minWidth: 'auto',
                    padding: '6px 12px',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img
                        src={`/img/flags/${getCurrentLanguage().flag}`}
                        alt={getCurrentLanguage().name}
                        style={{ width: 20, height: 15, objectFit: 'cover' }}
                    />
                    <span>
                        {getCurrentLanguage().name}
                    </span>
                    <span style={{ marginLeft: '4px', fontSize: '10px', opacity: 0.6 }}>▼</span>
                </Box>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'language-button',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 140,
                        mt: 0.5,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        border: '1px solid rgba(0,0,0,0.1)',
                        borderRadius: '4px'
                    }
                }}
            >
                {languages.map((language) => (
                    <MenuItem
                        key={language.code}
                        onClick={() => handleLanguageClick(language.code)}
                        selected={language.code === activeLanguage}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            py: 0.75,
                            px: 2,
                            fontSize: '0.875rem',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            },
                            '&.Mui-selected': {
                                backgroundColor: 'rgba(25, 118, 210, 0.12)',
                                '&:hover': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.16)'
                                }
                            }
                        }}
                    >
                        <img
                            src={`/img/flags/${language.flag}`}
                            alt={language.name}
                            style={{ width: 20, height: 15, objectFit: 'cover' }}
                        />
                        <span>
                            {language.name}
                        </span>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default LanguageList;
